// WARNING: Auto generated using terraform/write_aws_exports.sh

const amplifyConfig = {
    cognito: {
        REGION: "eu-central-1",
        USER_POOL_ID: "eu-central-1_SwEi8DCww",
        IDENTITY_POOL_ID: "eu-central-1:e6c7919d-bf78-4240-9cdd-097a436488e7",
        APP_CLIENT_ID: "5otb4h3ljmjd4g5bvegg5jobqb",
    },
    s3_upload: {
        BUCKET: "045426914407-gtms4-upload",
        REGION: "eu-central-1",
    },
    s3_static: {
        BUCKET: "045426914407-gtms4-static",
        REGION: "eu-central-1",
    },
    api: {
        ENDPOINT: "https://kiie082q48.execute-api.eu-central-1.amazonaws.com/v1",
        REGION: "eu-central-1",
    },
    map: {
        NAME: "gtms4-map",
        REGION: "eu-central-1",
    }
};
export default amplifyConfig;
